<template>
<div class="full" :class="{'shu':!is_heng}" style="display:flex;flex-flow:column;">
    <!-- 单选、多选、填空 等 -->
    <template v-if="question.description == ''">
        <div style="flex:1;overflow-y:auto;display:flex;flex-flow:column;">
            <div class="topic">
                <label>{{question.topic_num}}</label>
                <div class="text" v-html="question.content"></div>
            </div>
            <options :topic="question" @doRadio="doRadio" style="flex:1"/>
        </div>
        <div class="onlychose" style="border-top:1px solid #dcdcdc;background:#54596b;min-height:43px;" >
            <!-- <label class="topic_eq_num">{{question.topic_num}}</label> -->
            <label class="answer_icon" v-if="['1','2','3'].indexOf(question.question_type) > -1  ">请作答</label>
            <label style="float: left;color: #c3c3c3;line-height: 43px;position: absolute;left: 478px;">{{this.$store.state.user.user_name||'XXX'}} 111111111111111</label>
            <optionsChose :topic="question" @doRadio="doRadio" v-if="['1','2','3'].indexOf(question.question_type) > -1  "/>
            
        </div>
    </template>

    <!-- 案例分析题 -->
    <template v-if="question.description != ''">
        <div class="topic_left">

            <div v-if="question.description == 'pdf'" style="height:100%;" class="pdfWrap">
                <pdf class="pdf" :num="question.topic_num" :part="question.part_display_order"></pdf>
            </div>
            <div class="skill" v-if="question.description != 'pdf'">
                <a href="javascript:;" class="full" :class="{'cur':is_full}" @click="is_full=!is_full"></a>
                <a href="javascript:;" class="row" :class="{'cur':is_heng}" @click="is_heng=!is_heng"></a>
                <a href="javascript:;" class="smill" @click="font_size = font_size-1">缩小</a>
                <a href="javascript:;" class="big" @click="font_size=font_size+1">放大</a>
                <a href="javascript:;" class="NoStress" @click="setColor('#edfade')">取消强调</a>
                <a href="javascript:;" class="stress" @click="setColor('yellow')">强调显示</a>
            </div>
            
            <div  v-if="question.description != 'pdf'" class="text" :style="{'font-size':font_size+'px','line-height':font_size+'px'}" v-html="question.description"></div>
            
        </div>
        <div class="topic_right"  style="flex:1;display:flex;flex-flow: column;">
            <div style="flex:1;overflow-y:auto;display:flex;flex-flow:column;">
                <div class="topic">
                    <label>{{question.topic_num}}</label>
                    <div class="text" v-html="question.content"></div>
                </div>
                <options :topic="question" @doRadio="doRadio" style="flex:1"/>
            </div>
            <div class="onlychose" style="border-top:1px solid #dcdcdc;"  v-if="['1','2','3'].indexOf(question.question_type) > -1  ">
                <label class="topic_eq_num" >{{question.topic_num}}</label>
                <optionsChose :topic="question" @doRadio="doRadio" />
            </div>
        </div>
        <div style="border-top: 1px solid rgb(220, 220, 220);background: rgb(84, 89, 107);min-height: 43px;position: absolute;bottom: 0;right: 0;left: 0;">
            <label style="float: left;color: #c3c3c3;line-height: 43px;position: absolute;left: 448px;">{{this.$store.state.user.user_name||'XXX'}} 111111111111111</label>
        </div>

    </template>

</div>
</template>

<script>
import Config from "@/infrastructures/config.js"
import options from "@/components/paper/options"
import optionsChose from "@/components/paper/optionsChose"
import Pdf from "@/components/public/pdf"
export default {
    name: 'question',
    components: {
        options,
        optionsChose,
        Pdf
    },
    data() {
        return {
            is_full: false,
            is_heng: true,
            question: {},
            font_size: 16, //默认字号
            assetUrl: ""
        }
    },
    props: ['topic'],
    created() {
        this.assetUrl = Config.assetUrl;
    },
    watch: {

        topic: {
            immediate: true,
            handler(val) {
                if(val.description){
                    val.description = val.description.replace(/\$__URL__\$/g,Config.assetUrl);
                }
                if(val.content){
                    val.content = val.content.replace(/$__URL__$/,Config.assetUrl)
                }
                
                
                this.question = val;

            }
        },
        
        is_full(news) {
            this.$emit("isFull", news);
        },
        is_heng(news) {
            this.$emit("isHeng", news);
        }
    },
    methods: {
        doRadio(data){
            this.$emit("doRadio",data);
        },
        setColor(color){
            var tr;
            
            if(navigator.userAgent.indexOf("MSIE") > -1){
                tr = document.selection.createRange();
                if(tr.parentElement().className  == "editor" || tr.parentElement().parentNode.nodeName == "P"){
                    tr.execCommand("BackColor", false, color);
                    return;
                }
            }else{
                tr = window.getSelection().getRangeAt(0);
              
                //if(tr.commonAncestorContainer.parentNode.className == "stress" || tr.commonAncestorContainer.parentNode.nodeName == "NoStress"){
                    var span = document.createElement("font");
                    
                    span.style.cssText = "background-color:"+color;
                    
                    tr.surroundContents(span);
                //}
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.topic {
    padding-left: 50px;
    position: relative;
    line-height: 40px;
}

.topic label,.topic_eq_num {
    padding-left: 0;
    display: inline-block;
    width: 40px;
    height: 40px;
    font-size: 14px;
    color: #000000;
    text-align: center;
    line-height: 40px;
    background: #a7caf0;
    margin-right: 10px;
    position: absolute;
    left: 0;
}

.skill {
    text-align: right;
    border-bottom: 1px solid #dcdcdc;
    padding: 5px;
}

.skill span,.skill a {
    font-size: 14px;
    background: #e5e5e5;
    line-height: 19px;
    vertical-align: middle;
    color: #008dff;
    padding: 5px 10px;
    margin-bottom: 3px;
    height: 19px;
    display: inline-block;
    cursor: pointer;
    margin-left: 10px;
}

.subItem p {
    font-size: 16px;
}

.skill .stress {
    padding-left: 25px;
    background: #e5e5e5 url(~@/assets/image/exam/feij.png) 7px center no-repeat;
}

.skill .NoStress {
    padding-left: 25px;
    background: #e5e5e5 url(~@/assets/image/exam/qiang.png) 7px center no-repeat;
}

.skill .big {
    padding-left: 25px;
    background: #e5e5e5 url(~@/assets/image/exam/big.png) 7px center no-repeat;
}

.skill .row {
    width: 30px;
    display: inline-block;
    background: #e5e5e5 url(~@/assets/image/exam/two.png) center center no-repeat;
}

.skill .row.cur {
    background: #e5e5e5 url(~@/assets/image/exam/one.png) center center no-repeat;
}

.skill .smill {
    padding-left: 25px;
    background: #e5e5e5 url(~@/assets/image/exam/small.png) 7px center no-repeat;
}

.skill .full {
    width: 30px;
    display: inline-block;
    background: #e5e5e5 url(~@/assets/image/exam/screen.png) center center no-repeat;
}

.skill .full.cur {
    background: #e5e5e5 url(~@/assets/image/exam/fei.png) center center no-repeat;
}

.topic_left,
.topic_right {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 50%;
    overflow-y: auto;
    border-right: 1px solid #dcdcdc;
    box-sizing: border-box;
}

.topic_right {
    left: 50%;
    border: none;
}

.text {
    font-size: 16px;
    line-height: 30px;
    padding: 10px;
    /* font-family: '仿宋'; */
}

/* 案例题竖屏*/
.shu .topic_left,
.shu .topic_right {
    position: static;
    border-bottom: 1px solid #dcdcdc;
    width: 100%;
}
.answer_icon{color:#fff;background:url(~@/assets/image/exam/write.png) no-repeat 0 center;padding-left:35px;margin:0 50px 0 10px; float:left;line-height:43px;display:inline-block;
    &+div{margin-left:63px}
}
</style>
